style= require('./match-sources.styl')

section.controls
  .panel
    .control
      if seasons
        ft-dropdown.dropdown(icon)
          header.dropdown-header(slot="header")
            if this.sport
              .dropdown-icon
                ft-icon(name=`sports--${this.sport}`)
            span.dropdown-text=(this.sport) || 'All sports'
          each s in activeSeasons
            .dropdown-item(role='option', value=s, (click)=this.changeSport(s),selected=(s == this.sport))
              if s
                .dropdown-icon
                  ft-icon(name=`sports--${s}`)
              span= s 
      sporty-seasons(
        sport=this.sport,
        season=season,
        (change:season)=this.changeSeason(e),
        blank='<select a season>'
      )
      ft-toggle.advanced(
        checked=this.advancedMode,
        (change)=this.advancedMode = e.target.checked
      )='Advanced'
      ft-button(success, (click)=this.autoAssign())='Matching'
    .control
      ft-dropdown.dropdown(icon)
        header.dropdown-header(slot="header")
          span.dropdown-text=(this.uploadType)
        each t in ['matches', 'lineups', 'events']
          .dropdown-item(role='option', value=t, (click)=this.changeUploadType(t), selected=(t == this.uploadType))
            span= t
      ft-button((click)=this.upload(), disabled=!this.$file)='Upload CSV'
      ft-form-control.choose-file(type="file", (change)=this.setFile(e.target))
      if season?.lastMatchesUpdate
        -var by = (season.lastMatchesUpdate.by && season.lastMatchesUpdate.by.email) || 'noone'
        -var at = (season.lastMatchesUpdate && season.lastMatchesUpdate.at)
        ft-icon.bell(name='ui--notification_solid')
        .last-update
          .by= `Last update ${by}`
          if at
            .at= moment(at).format('lll')
      ft-button.confirm(primary, disabled=$isSubmitting, (click)=this.save())='Save'
each warning in warnings
  .warning
    ft-icon(name='ui--warning')
    = warning
    ft-icon(name='ui--warning')
section.desc-block
  .desc
    .status-yellow
    .title='Overrided Matches'
section.teams-info
  .field.entries
    .title
      .counter
        .name='Existing matches'
        .count.sourced= sortedMatches.length
      ft-form-control.search(
        type='search',
        (input)=this.updateFilter(e),
        value=search,
        placeholder='Search')
    if sortedMatches.length > 0
      each match in sortedMatches
        .entry(data-match=match._id)
          sporty-status(match=match, overrided=this.overridedTeams(match))
          .sources
            section.main
              label='Live stream URL'
              .value= match.liveStreamUrl
            section.main
              label='Live stream source'
              .value= match.liveStreamSource
            section.main
              label='External match page URL'
              .value= match.externalMatchPageUrl
            section.time
              label='Start Time'
              .value= match.startTime && moment(match.startTime).format('YYYY-MM-DD HH:mm')
            section.time
              label='Round'
              .value=match?.round
            section.time.extra(advanced-only=advancedMode)
              label='End Time'
              .value=match.endTime && moment(match.endTime).format('YYYY-MM-DD HH:mm')
            each field in customFields
              section.main.extra(advanced-only=advancedMode)
                label= field.name || field.normal
                .value=match[field.normal]
          ft-button(success, (click)=this.openModal(match))='Override'
          each source, index in this.sources(match)
            if source
              .mapped-source
                b(show = (index === 0))='Mapped'
                sporty-card.source(
                  class={dragged: source.$isDragged}
                  obj-id=source._id
                  obj-class='MatchSource'
                  header='source'
                  keys=cardKeys)
    else
      .no-players
        ft-icon(name='ui--sporty-stadium')
        .text= 'No matches to display'
  .field.new-entries(scroll=showScroll)
    .title
      .counter
        .name='New matches'
        .count.new= newMatches.length
      if newMatches.length > 0
        ft-button.undo(danger, (click)=this.clear())='Undo'
    each source in newMatches
      sporty-card.source(
        class={dragged: source.$isDragged}
        obj-id=source._id
        obj-class='MatchSource'
        header='name'
        keys=cardKeys)
    .submit((click)=this.openModal(-1))
      .plus= '+'
      .add= 'Add new match'
  .field.unassigned
    .title
      .counter
        .name='Unassigned matches'
        .count.no-source= nonSources.length
      section.search
        select.selector((change)=this.source = e.target.value || null)
          option(value='')="<All Sources>"
          if season
            each source in seasonSources
              option(value=source._id)= source.source
        ft-button(success, (click)=this.assignNew())='Auto-assign'
    if nonSources.length > 0
      each source in nonSources
        sporty-card.source(
          class={dragged: source.$isDragged}
          obj-id=source._id
          obj-class='MatchSource'
          header='name',
          keys=cardKeys)
    else
      .no-players
        ft-icon(name='ui--sporty-stadium')
        .text= 'No matches to display'
